module.exports = __webpack_public_path__ + "static/elephantcomfblanket2-03fc1bae3a593b0b998d75ac1e03cad5.jpeg";